import BaseApi from './base'

class VehicleModel extends BaseApi {
  getVehicleModels = (query) => this.client.get(`vehicle-model?${query}`)

  getVehicleModelDetail = (id) => this.client.get(`vehicle-model/${id}`)

  addVehicleModel = (data) => this.client.post('vehicle-model', data)

  updateVehicleModel = ({ vehicleModelId, payload }) =>
    this.client.patch(`vehicle-model/${vehicleModelId}`, payload)

  deleteVehicleModel = (id) => this.client.delete(`vehicle-model/${id}`)

  getVehicleModelsByVehicleBrand = (id) =>
    this.client.get(`vehicle-model/brand/${id}`)

  getSystemVehicleModels = (query) =>
    this.client.get(`systems/vehicle-model?${query}`, {
      baseURL: `${this.fleetURL}/backoffice`
    })
}

export default new VehicleModel()
